import { Pbx } from '@/customer-portal/pbx/entities/pbx'

export default class PbxResponse {
  public items: Pbx[] = []
}
